module.exports = __webpack_public_path__ + "img/fig07.b58a4695.jpg";